"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAd = deleteAd;
async function deleteAd(advertisingRepo, adId) {
    return advertisingRepo.deleteAd(adId);
}
